// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Form } from 'informed';

import { signup, SIGNUP_ERROR } from '../../actions/accountActions';

import { Button, PrimaryButton } from '../Buttons.jsx';
import { Error } from '../Typography.jsx';
import RequiredText from '../RequiredText.jsx';

import styles from '../../styles/accountPages/SignupPage.scss';

const publicUrl = process.env.PUBLIC_URL || '';

type Props = {
  signup: Function,
  passwordMismatch: Function,
  signupError: ?string,
}

class SignupPageComponent extends Component<Props> {
  formApi: {
    getState: Function,
    getValue: Function,
    setError: Function,
  }

  setFormApi = (formApi: Object) => {
    this.formApi = formApi;
  }

  enter = ({ key }) => {
    if (key === 'Enter') {
      this.submitSignup();
    }
  }

  submitSignup = () => {
    const state = this.formApi.getState();
    if (state.invalid) {
      return;
    }
    if (!this.formApi.getValue('username')) {
      this.formApi.setError('username', 'Error');
      return;
    }
    if (!this.formApi.getValue('password')) {
      this.formApi.setError('password', 'Error');
      return;
    }
    if (!this.formApi.getValue('confirmPassword')) {
      this.formApi.setError('confirmPassword', 'Error');
      return;
    }
    if (!this.formApi.getValue('name')) {
      this.formApi.setError('name', 'Error');
      return;
    }
    if (!this.formApi.getValue('credential')) {
      this.formApi.setError('credential', 'Error');
      return;
    }
    if (!this.formApi.getValue('institution')) {
      this.formApi.setError('institution', 'Error');
      return;
    }
    if (!this.formApi.getValue('masterKey')) {
      this.formApi.setError('masterKey', 'Error');
      return;
    }
    if (this.formApi.getValue('password') !== this.formApi.getValue('confirmPassword')) {
      this.props.passwordMismatch();
      return;
    }
    const { confirmPassword, ...signupInfo } = state.values;
    this.props.signup(signupInfo);
  }

  render() {
    return (
      <Form getApi={this.setFormApi} autoComplete='off'>
        <div className={styles.signupPage}>
          <div className={styles.signupBox} onKeyPress={this.enter}>
            <img className={styles.logoImage} src={`${publicUrl}/logo.png`} />
            <div className={styles.boxHeader}>Sign Up</div>
            <table>
              <tbody>
                <tr>
                  <td>Username: </td>
                  <td><RequiredText field='username' initialValue={''} /></td>
                </tr>
                <tr>
                  <td>Password: </td>
                  <td><RequiredText field='password' type='password' initialValue={''} /></td>
                </tr>
                <tr>
                  <td>Confirm Password: </td>
                  <td><RequiredText field='confirmPassword' type='password' initialValue={''} /></td>
                </tr>
                <tr>
                  <td>Full Name: </td>
                  <td><RequiredText field='name' initialValue={''} /></td>
                </tr>
                <tr>
                  <td>Credential: </td>
                  <td><RequiredText field='credential' initialValue={''} /></td>
                </tr>
                <tr>
                  <td>Institution: </td>
                  <td><RequiredText field='institution' initialValue={''} /></td>
                </tr>
                <tr>
                  <td>Master Key: </td>
                  <td><RequiredText field='masterKey' type='password' initialValue={''} /></td>
                </tr>
              </tbody>
            </table>
            <div className={styles.buttonsBox}>
              <PrimaryButton onClick={this.submitSignup}>Sign Up</PrimaryButton>
              <Link to='/'><Button>Cancel</Button></Link>
            </div>
            <Error>{this.props.signupError}</Error>
          </div>
        </div>
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  signupError: state.account.signupError,
});

const mapDispatchToProps = dispatch => ({
  signup: userInfo => dispatch(signup(userInfo)),
  // fire an action to display sign up error client side, instead of sending confirmPassword server side
  passwordMismatch: () => dispatch({
    type: SIGNUP_ERROR,
    error: 'Passwords do not match',
  }),
});

const SignupPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SignupPageComponent);

export default SignupPage;



// WEBPACK FOOTER //
// ./client/src/components/accountPages/SignupPage.jsx